// extracted by mini-css-extract-plugin
module.exports = {"Table":"CostBenefit_Table__6tIu1","CompactTable":"CostBenefit_CompactTable__fvML_"};